import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation';

export default function Video() {
  const { t } = useTranslation();
  return (
    <section className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6 text-gray-900">{t('video.title')}</h2>
          <p className="text-lg sm:text-xl text-gray-700 max-w-3xl mx-auto px-4">
            {t('video.subtitle')}
          </p>
        </div>
        
        <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl sm:rounded-3xl p-4 sm:p-8 md:p-12 border border-gray-200 shadow-xl">
          <div className="max-w-5xl mx-auto">
            {/* Адаптивный видео контейнер */}
            <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
              <div className="absolute inset-0 rounded-xl sm:rounded-2xl overflow-hidden shadow-2xl bg-gray-800">
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/LoArxTJcNBc?rel=0&modestbranding=1&showinfo=0&controls=1&fs=1"
                  title={t('video.video_title')}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  className="w-full h-full"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
